import * as React from 'react';
import {useContext} from 'react';
import {StoreContext} from "../../stores/StoreLoader";
import SimpleAndFloating from "./SchoolBlocksHeaderThemes/SimpleAndFloating";
import MinimalTheme from "./SchoolBlocksHeaderThemes/MinimalTheme";
import {MobileNavFooter} from './navigation/MobileNav/MobileNavFooter';
import {observer} from "mobx-react";
import {sb_scrollWindowTo} from "../../utils/SchoolBlocks";
import styles from "./styles/SchoolBlocksHeader.module.scss";
import {YiiUrlFactory} from "../../backends/YiiRoutes";

const SchoolBlocksHeader: React.FC<{}> = observer(props => {
    const {i18nStore, styleStore, modalStore, organizationStore, interfaceStore} = useContext(StoreContext);

    function openLoginModal() {
        modalStore.addModal({
            type: 'login',
            id: 'login-modal',
        })
    }

    function toggleUserMenu() {
        sb_scrollWindowTo();
        interfaceStore.toggleUserMenu();
    }

    const mainUrl = YiiUrlFactory(
        organizationStore.organization.json_data.settings.appearance.showWelcomePage ? "/?showHomepage=true" : "/",
        i18nStore.currentOrgSupportedLocale
    );

    const theme = (styleStore.themeID === "1" || styleStore.themeID === "2" ?
        <SimpleAndFloating
            toggleUserMenu={toggleUserMenu}
            openLoginModal={openLoginModal}
            mainUrl={mainUrl}
        />
        :
        <MinimalTheme
            toggleUserMenu={toggleUserMenu}
            openLoginModal={openLoginModal}
            mainUrl={mainUrl}
        />
    );

    const header = <div className={styles.centerContent}>
        <MobileNavFooter mainUrl={mainUrl} />
        {theme}
    </div>

    return header;
})

export default SchoolBlocksHeader;
